import { render, staticRenderFns } from "./smartLifeIndex.vue?vue&type=template&id=020a59ab&scoped=true"
import script from "./smartLifeIndex.vue?vue&type=script&lang=js"
export * from "./smartLifeIndex.vue?vue&type=script&lang=js"
import style0 from "./smartLifeIndex.vue?vue&type=style&index=0&id=020a59ab&prod&lang=css"
import style1 from "./smartLifeIndex.vue?vue&type=style&index=1&id=020a59ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a59ab",
  null
  
)

export default component.exports